<div class="logo">
  @if (isExpanded()) {
    <img src="../assets/images/toolhive-full-logo.svg" alt="Toolhive" />
  } @else {
    <img src="../assets/images/toolhive-logo.svg" alt="Toolhive" />
  }
</div>
<div class="divider"><tfs-divider></tfs-divider></div>

<mat-nav-list class="nav-links">
  @for (section of navLinks(); track $index; let isLast = $last) {
    @for (item of section; track item.name) {
      <a
        mat-list-item
        #link="routerLinkActive"
        [routerLink]="item.disabled ? null : item.route"
        [activated]="link.isActive"
        [disabled]="item.disabled"
        routerLinkActive
        [routerLinkActiveOptions]="{ exact: false }"
        [matTooltip]="item.tooltip || ''"
        [matTooltipDisabled]="!item.tooltip"
        matTooltipPosition="right"
        [attr.aria-current]="link.isActive ? 'page' : 'false'">
        @if (item.name === 'Tool comparison' && toolComparisonCount() > 0) {
          <span
            matListItemIcon
            [matBadge]="toolComparisonCount()"
            matBadgeSize="large"
            matBadgePosition="above after"
            aria-hidden="false"
            [attr.aria-label]="'Tool comparison, ' + toolComparisonCount() + ' items'">
            <mat-icon [tfsIcon]="item.icon" />
          </span>
        } @else {
          <mat-icon matListItemIcon [tfsIcon]="item.icon" />
        }
        @if (isExpanded()) {
          <span>{{ item.name }}</span>
        }
      </a>
    }
    @if (!isLast) {
      <div class="divider"><tfs-divider></tfs-divider></div>
    }
  }

  <tfs-data-sync-nav-item
    [isExpanded]="isExpanded()"
    [disabled]="isSubscriptionInactive()"
    [tooltip]="dataSyncTooltip()" />
</mat-nav-list>

<mat-nav-list class="bottom-nav-links">
  @for (item of bottomNavLinks(); track item.name) {
    <a
      mat-list-item
      #link="routerLinkActive"
      [routerLink]="item.route"
      [activated]="link.isActive"
      routerLinkActive
      [routerLinkActiveOptions]="{ exact: false }"
      [attr.aria-current]="link.isActive ? 'page' : 'false'">
      <mat-icon matListItemIcon [tfsIcon]="item.icon" />
      @if (isExpanded()) {
        <span>{{ item.name }}</span>
      }
    </a>
  }

  <a
    mat-list-item
    class="academy-link"
    href="https://toolhive.in.howspace.com/?path=%2Fwelcome"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Academy (opens in new tab)">
    <mat-icon matListItemIcon tfsIcon="books" />
    @if (isExpanded()) {
      <span>Academy</span>
    }
    @if (isExpanded()) {
      <mat-icon matListItemMeta tfsIcon="arrow-square-out" />
    }
  </a>

  <a
    mat-list-item
    cdkOverlayOrigin
    #profileOrigin="cdkOverlayOrigin"
    (mouseenter)="showProfilePanel()"
    (mouseleave)="hideProfilePanel()">
    <mat-icon matListItemIcon tfsIcon="user-circle" />
    @if (isExpanded()) {
      <span>{{ profileName() }}</span>
    }
  </a>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="profileOrigin"
    [cdkConnectedOverlayOpen]="isProfilePanelOpen()"
    [cdkConnectedOverlayHasBackdrop]="false"
    [cdkConnectedOverlayPositions]="[
      { originX: 'end', originY: 'bottom', overlayX: 'start', overlayY: 'bottom', offsetX: 8 },
    ]">
    <div (mouseenter)="keepProfilePanel()" (mouseleave)="dismissProfilePanel($event)">
      <app-profile-panel (closePanel)="closeProfilePanel()" (logout)="onLogout()" />
    </div>
  </ng-template>
</mat-nav-list>

<div class="divider"><tfs-divider></tfs-divider></div>

<button type="button" class="collapse-toggle" (click)="toggleNav()">
  <mat-icon [tfsIcon]="isExpanded() ? 'caret-double-left' : 'caret-double-right'" />
  @if (isExpanded()) {
    <span>Collapse</span>
    <mat-icon tfsIcon="caret-double-left" />
  }
</button>
